import axios, { AxiosError } from 'axios';
import SettingsDirectAccess from 'store/settings/directAccess';
import { AuthResponse, AuthRequest } from 'types/auth';
import { formatEndpoint } from '..';
import { formatAxiosError } from '../api-error-handler';

class AuthorizationRepository {
  async createAuth(): Promise<AuthResponse> {
    const settings = SettingsDirectAccess.getSettings();
    const endpoint = formatEndpoint(settings.endpoint);
    const request: AuthRequest = {
      clientId: settings.clientId,
      clientSecret: settings.clientSecret,
    };
    try {
      const { data } = await axios.post<AuthResponse>(`${endpoint}authorization`, request);

      return data;
    } catch (error) {
      throw formatAxiosError(error as AxiosError, 'An error has occured while authorizing.');
    }
  }
}

export default new AuthorizationRepository();
